import { Link } from 'react-router-dom'
import {
  HERO_CAROUSEL,
  type BannerCtaLinkProps,
  type HomePromoBannersProps,
} from '../constants/home'
import { cx } from '../helpers/format'
import '../styles/home-page.scss'

function BannerCtaLink({
  label,
  url,
  external,
  className,
  children,
}: BannerCtaLinkProps) {
  if (external) {
    return (
      <a
        href={url}
        className={className}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={label}
      >
        {children ?? label}
      </a>
    )
  }

  return (
    <Link to={url} className={className} aria-label={label}>
      {children ?? label}
    </Link>
  )
}

export function HomePromoBanners({ banners }: HomePromoBannersProps) {
  if (banners.length === 0) return null

  return (
    <section className="section home-promo" aria-label="Promotions">
      <div className="home-promo__frame">
        <div className="home-promo__stack">
          {banners.map((banner) => {
            const bannerClassName = cx(
              'home-promo__banner',
              banner.mobileImageUrl && 'has-mobile-art',
            )
            const media = banner.imageUrl ? (
              <picture>
                {banner.mobileImageUrl ? (
                  <source
                    media={`(max-width: ${HERO_CAROUSEL.mobileMaxWidthPx}px)`}
                    srcSet={banner.mobileImageUrl}
                  />
                ) : null}
                <img
                  src={banner.imageUrl}
                  alt={banner.title}
                  className="home-promo__image"
                />
              </picture>
            ) : (
              <div className="home-promo__fallback">
                <h3>{banner.title}</h3>
                {banner.subtitle ? <p>{banner.subtitle}</p> : null}
                {banner.ctaUrl && banner.ctaLabel ? (
                  <BannerCtaLink
                    label={banner.ctaLabel}
                    url={banner.ctaUrl}
                    external={banner.ctaIsExternal}
                    className="home-promo__cta"
                  />
                ) : null}
              </div>
            )

            if (banner.ctaUrl && banner.imageUrl) {
              return (
                <BannerCtaLink
                  key={banner.id}
                  label={banner.ctaLabel ?? banner.title}
                  url={banner.ctaUrl}
                  external={banner.ctaIsExternal}
                  className={bannerClassName}
                >
                  {media}
                </BannerCtaLink>
              )
            }

            return (
              <article key={banner.id} className={bannerClassName}>
                {media}
              </article>
            )
          })}
        </div>
      </div>
    </section>
  )
}
